import type { MailboxInfo } from "owa-client-types";
import store from "../store/Store";

export function getEnabledFlightsWithPrefix(prefix: string, mailboxInfo?: MailboxInfo): string[] {
    const featureFlags = store(mailboxInfo).featureFlags;
    return [...featureFlags.keys()].filter(f => f.indexOf(prefix) == 0 && featureFlags.get(f.toLowerCase()));
}
